export const LIST_ITEM_MEDIA_WIDTH = 160;
export const LIST_ITEM_MEDIA_HEIGHT = 90;

export const LIST_ITEM_MEDIA_WIDTH_MOBILE = 107;
export const LIST_ITEM_MEDIA_HEIGHT_MOBILE = 60;
